import ReactDOM from 'react-dom/client';
import { v2Component } from '../../../index';
import { OrderInvoices } from './order-invoices';
import { AdminContextProvider } from '../../../context/admin-context';
import { ToastContainer } from 'react-toastify';

export function initOrderDetails() {
  document.getElementsByName('order-invoices').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { orderId } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <AdminContextProvider>
              <ToastContainer />
              <OrderInvoices orderId={orderId} className="mt-[18px]" />
            </AdminContextProvider>,
          ),
        );
      };

      bootstrap();
    }
  });
}
